export const RADIX_SIDE_OFFSET = 8;
export const RADIX_COLLISION_PADDING = 8;

// This matches Startup.cs in the backend
export const MAX_ALLOWED_UPLOAD_FILE_SIZE = 50 * 1024 * 1024; // 50MB
